<div class="favorite-wrapper">
  <ion-fab-button
    (click)="onToggle()"
    class="white"
    [class.is-favorited]="entity()?.metrics?.currentUserFavorite">

    <div class="material-symbols-outlined">
      {{ iconType() }}
    </div>
  </ion-fab-button>

  <div
    class="badge-count"
    [class.is-favorited]="entity()?.metrics?.currentUserFavorite"
    *ngIf="entity()?.metrics?.totFavorite > 0">
    {{ entity()?.metrics?.totFavorite }}
  </div>
</div>
